import React from 'react';
interface ChatBubbleProps {
  message: string;
  isOwn: boolean;
  timestamp: string;
  isSystem?: boolean;
  avatar?: string;
}
export function ChatBubble({
  message,
  isOwn,
  timestamp,
  isSystem = false,
  avatar
}: ChatBubbleProps) {
  if (isSystem) {
    return <div className="flex justify-center my-4" data-id="element-167">
        <div className="bg-sand/40 px-4 py-3 rounded-ios max-w-[85%]" data-id="element-168">
          <p className="text-xs text-charcoal/70 text-center leading-relaxed" data-id="element-169">
            {message}
          </p>
        </div>
      </div>;
  }
  return <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-3`} data-id="element-170">
      {!isOwn && avatar && <img src={avatar} alt="Avatar" className="w-8 h-8 rounded-full object-cover mr-2 mt-auto mb-5" data-id="element-171" />}
      <div className={`max-w-[75%] ${isOwn ? 'items-end' : 'items-start'} flex flex-col gap-1`} data-id="element-172">
        <div className={`px-4 py-3 rounded-ios-lg ${isOwn ? 'bg-dark-green text-white rounded-br-sm' : 'bg-white text-charcoal rounded-bl-sm shadow-sm border border-sand/50'}`} data-id="element-173">
          <p className="text-sm leading-relaxed" data-id="element-174">{message}</p>
        </div>
        {timestamp && <span className="text-xs text-moss-gray px-1" data-id="element-175">{timestamp}</span>}
      </div>
    </div>;
}